// extracted by css-extract-rspack-plugin
export default {"empty":"mzVF197LFfMSfdZI"};